class View {
    #parentEl = document.querySelector('.container');
    #row = document.querySelector('.row');
    #submitBtn = document.querySelector('#submit-btn');
    #btnBox = document.querySelectorAll('.btn-box');
    #input = document.querySelector('.input');
    #title = document.querySelector('#title')
    #guessNum = document.querySelector('#guess-num');
   
    #data;
    renderWord(data) {
        this.#data = data;
        let markup = '';

        this.#data.loadedWord.forEach((el, index) => {
            markup = markup + this.generateMarkup(el, index)
        })
        this.#parentEl.insertAdjacentHTML('afterbegin', markup)
    }



    renderLetters(data) {
        let numOfBox = data.player.wordEntered.length;
        let markup = '';
        console.log(numOfBox);

        for (let index = 0; index < numOfBox; index++) {
            markup = markup + this.generateMarkup(data.player.wordEntered[index], index);

        }
        this.#parentEl.innerHTML = '';
        this.#parentEl.insertAdjacentHTML('afterbegin', markup);
        this.showCorrectLetters(data);
    }
    showCorrectLetters(data) {
        console.log(data);

        const btnBoxes = document.querySelectorAll('.btn-box');


        for (let index = 0; index < btnBoxes.length; index++) {

            console.log(data.player.truePosition);

            if (btnBoxes[index].dataset.index == data.player.indexOfLetter[index]) {
                console.log(data.player.indexOfLetter[index], '<<<<');
                btnBoxes[index].classList.add('unplaced')
            }


            if (data.player.truePosition.length > 0) {
                data.player.truePosition.forEach((el, elIndex) => {
                    if (el == btnBoxes[index].dataset.index) {
                        btnBoxes[index].classList.add('correct')
                    }
                })
            }
        }
        if(data.player.win){
            this.#title.innerText='you won!'
        }
    }
    updateGuess(data){
        if(data.player.win){
              this.#title.innerText = `  فزت لقد بــــ     ${data.player.guessNum } محاولات     `;
           
        }else{

            console.log( 'the guesses left : ',data.player.guessNum);
            this.#guessNum.innerText = data.player.guessNum;
        }
       
    }
    generateMarkup(letter, index) {

        const markup = `
        
                         <div class="btn-box " data-index=${index}  >
                         <button class="btn">${letter}</button>
                         </div>
        
                           `;


        return markup;

    }

    adEventHandler(cb) {


        this.#submitBtn.addEventListener('click', (ev) => {
            const enteredWord = [...(this.#input.value)];
            cb(enteredWord)


        })
    }
}

export default new View;